import { useState, useEffect } from 'react';
import Modal from './Modal';
import ContactForm from './ContactForm';

const Hero = () => {
  const phrases = ["building", "shipping", "scaling"];
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [showContactModal, setShowContactModal] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentPhraseIndex((i) => (i + 1) % phrases.length);
        setIsVisible(true);
      }, 500);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const handlePrimaryClick = () => {
    setShowContactModal(true);
  };

  const closeContactModal = () => {
    setShowContactModal(false);
  };

  return (
    <>
      <section className="hero">
        <div className="hero-content hero-content-centered">
          <div className="hero-text hero-text-centered">
            <p className="hero-overline">AI & DATA IMPLEMENTATION SPECIALISTS</p>
            <h1>
              Stop talking about AI, and start&nbsp;
              <span className={`rotating-text ${isVisible ? 'visible' : 'hidden'}`}>
                {phrases[currentPhraseIndex]}.
              </span>
            </h1>
            <p className="hero-subtitle">
              We are a founder-led AI & data implementation company. We help companies turn vague AI ambitions into real-world systems that deliver measurable impact.
            </p>
            <div className="hero-buttons">
              <button className="btn btn-primary" onClick={handlePrimaryClick}>
                Let's talk about your AI strategy →
              </button>
            </div>
            <p className="hero-trust-statement">
              Our team has experience spanning small startups to Fortune 500 companies.
            </p>
          </div>
        </div>
      </section>

      <Modal 
        isOpen={showContactModal} 
        onClose={closeContactModal}
        title="Request a Meeting"
      >
        <ContactForm onClose={closeContactModal} />
      </Modal>
    </>
  );
};

export default Hero;
